import { InstrumentationParam } from '../instrumentation/instrumentation.service';
import { FileItem } from '../models/file-item.model';
import { DocumentInfo } from '../models/wac-host.model';

export function createWacContentInstrumentationParams(
    correlationId: string,
    documentInfo: DocumentInfo,
    additionalParams = {}
): {} {
    return {
        [InstrumentationParam.ResourceId]: correlationId,
        [InstrumentationParam.WacHostEntry]: documentInfo.wdOrigin,
        [InstrumentationParam.FileFormat]: FileItem.fileTypeNameFromType(documentInfo.fileType),
        ...additionalParams
    };
}
